import { useContext } from 'react';
import { UserContext, IUserContext } from '../UserContext';

export const useProfiles = (): IUserContext => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useUserProfiles must be used within UserContext.Provider');
  }

  return context;
};
